import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {LayoutService} from '../../../../../core';
import {NotificationsService} from './notifications.service';
import {StompService} from '../../../../../../_upsell/shared/services/stomp.service';
import * as moment from 'moment/moment';

@Component({
    selector: 'app-notifications-dropdown-inner',
    templateUrl: './notifications-dropdown-inner.component.html',
    styleUrls: ['./notifications-dropdown-inner.component.scss'],
})
export class NotificationsDropdownInnerComponent implements OnInit, OnDestroy {

    // Notification Data
    unreadNotifications = [];
    numberOfNewNotifications = 0;

    // Sorting
    dataSize = 15;
    maxDataSize = 0;

    // Events
    @Output() newNotif = new EventEmitter<boolean>();

    // Subscriptions
    subscriptions = [];

    constructor(private layout: LayoutService,
                private notificationsService: NotificationsService,
                private stompService: StompService) {
        this.currentUserNotifications();
        this.subscribeToSocket();

    }

    ngOnInit(): void {


    }

    currentUserNotifications() {
        const newNotifications = this.notificationsService.getNewNotificationNumber().subscribe((notifNumber: any) => {
            this.numberOfNewNotifications = notifNumber.number;
        });


        const notifications = this.notificationsService.currentUserNotifications('0', this.dataSize).subscribe((notifs: any) => {
            this.unreadNotifications = [];
            this.maxDataSize = notifs.totalElements;

            notifs.content.forEach(notification => {
                // Get only the unread notifications
                if (notification.usersListStatus[0].status === 'new') {
                    this.unreadNotifications.push({
                        id: notification.id,
                        title: notification.message,
                        link: notification.createdObjectId,
                        createdAt: moment(notification.creationDate).fromNow(),
                        type: notification.type,
                        category: notification.category,
                        status: notification.usersListStatus[0].status
                    });
                }
            });

            this.parentNotification();

        });

        this.subscriptions.push(notifications, newNotifications);
    }

    // Mark as Read
    markAllAsRead() {
        const markAllAsRead = this.notificationsService.markAllAsRead().subscribe(() => {});
        this.subscriptions.push(markAllAsRead);
    }

    markOneAsRead(id) {
        const markOneAsRead = this.notificationsService.markOneAsRead(id).subscribe(() => {});
        this.subscriptions.push(markOneAsRead);
    }

    // Socket
    subscribeToSocket() {
        

        this.stompService.subscribe('/topic/messages', (): void => {
            
            this.currentUserNotifications();
        });

        this.stompService.subscribe('/topic/create', (): void => {
            
            this.currentUserNotifications();
        });

        this.stompService.subscribe('/topic/user-notifications', (): void => {
            
            this.currentUserNotifications();
        });
    }

    // Send notification to parent component
    parentNotification() {
        if (this.unreadNotifications.length > 0) {
            this.newNotif.emit(true);
        } else {
            this.newNotif.emit(false);
        }
    }

    onScroll() {
        if (this.dataSize < this.maxDataSize) {
            this.dataSize += 10;
            this.currentUserNotifications();
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sb => sb.unsubscribe());
    }

    createNotif() {
        this.notificationsService.createNotification('A new ticket has been created.', '1', 'CRM', 'ticket', ['62a98a8ec9c79611508374e5']).subscribe((responseNotif: any) => {
            
            
        });
    }
}
